import Vue from "vue";
import { getField, updateField } from "vuex-map-fields";
import { axiosCall } from "../../utils/axiosCall";

function initialState() {
  return {
    comparativeData: {},
    selectedOrganizations: [],
    selectedTags: [],
    advancedData_mainFilterBar_year: null,
    selectedYearFilter: [],
    selfAssessment_general_business_locationCountry_id: null,
    selfAssessment_general_classification_sector: null,
    selfAssessment_general_classification_activityAggregated: null,
    selfAssessment_general_classification_activityDetailed: null,
    selfAssessment_general_classification_market_international: null,
    selfAssessment_general_classification_market_national: null,
    selfAssessment_general_classification_market_local: null,
    selfAssessment_general_size_numberEmployees: null,
    selfAssessment_general_size_revenue: null,
    selfAssessment_general_business_organizationType: null,
    selectOrganizationsManually: false,
    selectYearsManually: false,
    selectTagsManually: false,
    yearEnabled: false,
    locationEnabled: false,
    economicSectorEnabled: false,
    aggregatedEconomicActivityEnabled: false,
    activityDetailedEnabled: false,
    targetedMarketEnabled: false,
    numberOfEmployeesEnabled: false,
    anualRevenueEnabled: false,
    organizationTypeEnabled: false,
    consolidatedData: {},
    generalIndexConsolidated: null,
    pillarsIdsConsolidated: null,
    tabIndex: 0,
  };
}

const state = initialState;

const getters = {
  getComparativeData: (state) => state.comparativeData,
  getConsolidatedData: (state) => state.consolidatedData,
  getPillarsIdsConsolidated: (state) => state.pillarsIdsConsolidated,
  getPillarsDataConsolidated: (state) => state.pillarsDataConsolidated,
  getGeneralIndexConsolidated: (state) => state.generalIndexConsolidated,
  pillarDataConsolidated: (state) => (pillarId) => {
    return state.pillarsDataConsolidated.find((x) => x.id === pillarId);
  },
  indicatorsDataByPillarIdConsolidated: (state) => (pillarId) => {
    return state.pillarsDataConsolidated.find((x) => x.id === pillarId)
      .children;
  },
  getIndicatorDataConsolidated: (state) => (pillarId, indicatorId) => {
    const indicator = state.pillarsDataConsolidated.find(
      (x) => x.id === pillarId
    );
    return indicator.children.find((x) => x.id === indicatorId);
  },
  currentPillarIdConsolidated: (state) => state.currentPillarIdConsolidated,
  currentIndicatorIdConsolidated: (state) =>
    state.currentIndicatorIdConsolidated,
  getPillarData: (state) => (pillar) => {
    if (
      !state.comparativeData ||
      !state.comparativeData.pillars ||
      !state.comparativeData.pillars[pillar]
    ) {
      return null;
    }
    return state.comparativeData.pillars[pillar].children;
  },
  getPillarIndex: (state) => (pillar) => {
    if (
      !state.comparativeData ||
      !state.comparativeData.pillars ||
      !state.comparativeData.pillars[pillar]
    ) {
      return null;
    }
    return state.comparativeData.pillars[pillar].generalIndex;
  },
  getPillarName: (state) => (pillar) => {
    if (
      !state.comparativeData ||
      !state.comparativeData.pillars ||
      !state.comparativeData.pillars[pillar]
    ) {
      return null;
    }
    return state.comparativeData.pillars[pillar].name;
  },
  getPillarDescription: (state) => (pillar) => {
    if (
      !state.comparativeData ||
      !state.comparativeData.pillars ||
      !state.comparativeData.pillars[pillar]
    ) {
      return null;
    }
    return state.comparativeData.pillars[pillar].description;
  },
  getYears: () => () => {
    const YEARS = ["2019"];
    return YEARS;
  },
  getAdvancedDataField: (state) => {
    return getField(state);
  },
};

const mutations = {
  updateField,
  setComparativeData: (state, data) => {
    Vue.set(state, "comparativeData", data);
  },
  updateAdvancedDataField: (state, field) => {
    updateField(state, field);
  },
  setPillarsDataConsolidated(state, data) {
    Vue.set(state, "pillarsDataConsolidated", data);
  },
  setPillarsIdsConsolidated(state, pillarsIds) {
    Vue.set(state, "pillarsIdsConsolidated", pillarsIds);
  },
  pillarsDataConsolidated: (state, data) => {
    Vue.set(state, "comparativeData", data);
  },
  setConsolidatedData: (state, data) => {
    Vue.set(state, "consolidatedData", data);
  },
  setgeneralIndexConsolidated: (state, data) => {
    Vue.set(state, "generalIndexConsolidated", data);
  },
  setReportDataConsolidated(state, data) {
    state.reportData = data;
  },
  setCurrentPillarIdConsolidated(state, pillarId) {
    Vue.set(state, "currentPillarIdConsolidated", pillarId);
  },
  setCurrentIndicatorIdConsolidated(state, indicatorId) {
    Vue.set(state, "currentIndicatorIdConsolidated", indicatorId);
  },
};

const actions = {
  COMPAREPILLARS_REPORT: (_, data) => {
    return new Promise((resolve, reject) => {
      /*
        data: {
          Companies: data.Companies,
          Years: [],
          Tags: [],
          Locations: [],
          Sizes: [],
          Activities: [],
          Types: ['optionList_selfAssessment_general_business_organizationType_private']
        }
      */
      axiosCall({
        url: "Pillars/compareReport?showSpinner=true",
        method: "POST",
        data,
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  CONSOLIDATE_PILLARS_REPORT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axiosCall({
        url: "Pillars/consolidatedReport?showSpinner=true",
        method: "POST",
        data,
      })
        .then((resp) => {
          if (!resp.data.error) {
            /* Pillars*/
            var pillars = resp.data.pillars.children;
            var pillarsIds = [];
            for (const pillar in pillars) {
              if (
                pillarsIds.filter((s) => s === pillars[pillar].id).length === 0
              ) {
                pillarsIds.push(pillars[pillar].id);
              }
            }
            commit("setReportDataConsolidated", resp.data.pillarsData);
            commit("setPillarsDataConsolidated", pillars);
            commit("setPillarsIdsConsolidated", pillarsIds);
            commit("setCurrentPillarIdConsolidated", "OP");
            commit("setCurrentIndicatorIdConsolidated", "OP1");

            commit("setConsolidatedData", resp.data);
            commit("setgeneralIndexConsolidated", resp.data.generalIndex);
          }
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  COMPAREPILLARS_REPORT_FILTERS: () => {
    return new Promise((resolve, reject) => {
      axiosCall({
        url: "Pillars/compareReportFilters",
        method: "GET",
        data: {},
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
          // commit('setOpinionSurveyStatus', { status: 'error', key: 'opinionSurvey' })
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
